import React from 'react'

// Recibimos data (la imagen/acción) y config (las posiciones y escala)
const SelfieFan = ({ data, config }) => {
    
    // Si no hay datos de imagen o la acción es hide, no renderizamos nada
    if (!data || !data.image || data.action === 'hide') return null;

    // Extraemos la configuración (con valores por defecto por seguridad)
    const { offsetX = 0, offsetY = 0, scale = 1 } = config || {};

    // Detectamos si es el QR u otra imagen
    const isQR = data.action === 'show_qr';

    return (
        <div 
            className='SelfieFan__Screen--Overlay' 
            style={{ 
                position: 'absolute',
                bottom: `${0 + offsetY}px`, 
                right: `${0 + offsetX}px`,
                transform: `scale(${scale})`,
                transformOrigin: 'bottom right',
                transition: 'all 0.2s ease-out'
            }}
        >
            {!data.type && (
                <img src='/img/selfiefan/Adsl-FanCam.png' className='SelfieFan__Screen--Overlay__Logo' alt="Logo" />
            )}
            {data.type === 'selfie' && (
                <>
                    <img src='/img/selfiefan/Adsl-FanCam.png' className='SelfieFan__Screen--Overlay__Logo' alt="Logo" />
                    <p className='mb-0 fs-5 text-center mt-2 text-white'>Envía tu foto</p>
                </>
            )}
            {data.type === 'message' && (
                <>
                    <img src='/img/page/adsl-five.png' className='SelfieFan__Screen--Overlay__Logo' alt="Logo" style={{ width: '150px' }} />
                    <p className='mb-0 fs-5 text-center mt-2 text-white'>Envía tu mensaje</p>
                </>
            )}

            {/* Inyectamos el base64 dinámico o el QR */}
            <img
                src={data.image}
                //src='/img/overlays/selfiefan/qrselfiefan.png'
                className={`SelfieFan__Screen--Overlay__Image SelfieFan__Screen--Overlay__Image--Small`}
                alt={isQR ? "QR Code" : "Fan Cam"}
                style={isQR ? { objectFit: 'contain', backgroundColor: '#D9D9D9', padding: '5px' } : {}}
            />

            <p className='SelfieFan__Screen--Overlay__Credits'>Powered by Interaktia</p>
        </div>
    );
};

export { SelfieFan };








// Funcional
// import React from 'react'

// // Recibimos data (la imagen) y config (las posiciones y escala)
// const SelfieFan = ({ data, config }) => {
    
//     // Si no hay datos de imagen (action='hide'), no renderizamos nada, dejamos el OBS transparente
//     if (!data || !data.image) return null;

//     // Extraemos la configuración (con valores por defecto por seguridad)
//     const { offsetX = 0, offsetY = 0, scale = 1 } = config || {};

//     return (
//         <div 
//             className='SelfieFan__Screen--Overlay' 
//             style={{ 
//                 position: 'absolute',
//                 // Partimos del bottom/right de 20px y le sumamos lo que diga el Admin
//                 bottom: `${0 + offsetY}px`, 
//                 right: `${0 + offsetX}px`,
//                 // Aplicamos la escala y definimos que crezca desde la esquina inferior derecha
//                 transform: `scale(${scale})`,
//                 transformOrigin: 'bottom right',
//                 // Transición suave para que al mover los sliders se vea animado y fluido
//                 transition: 'all 0.2s ease-out'
//             }}
//         >
//             <img src='/img/selfiefan/Adsl-FanCam.png' className='SelfieFan__Screen--Overlay__Logo' alt="Logo" />

//             {/* Inyectamos el base64 dinámico que nos mandó el C# */}
//             <img
//                 src={data.image}
//                 className='SelfieFan__Screen--Overlay__Image SelfieFan__Screen--Overlay__Image--Small'
//                 alt="Fan Cam"
//             />

//             <p className='SelfieFan__Screen--Overlay__Credits'>Powered by Interaktia</p>
//         </div>
//     );
// };

// export { SelfieFan };